var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "LOGO",
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    viewBox: "102.8 123.2 390.5 265.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "LOGO"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M248 123.2v221.7l41.4 44V123.2H248zm-104.3 23.6l12 44.8 37.6-15.5v110.7l-90.5-96.2 40.9-43.8zm56.7-23.6L144 146.5l21.9-23.3h34.5zM325.2 123.2v46.9h92.2l-88.2 194.8-22.6 24V123.2h18.6zm168.1 67.3l-55 58.5 35.8-79 19.2 20.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fb3bc92ef28a3808016b18a21cb10e00.svg";
export { ForwardRef as ReactComponent };